import React from "react";
import { useDispatch } from "react-redux";
/*import {
  configurationCleanSearchText,
  configurationSetSearchText,
  cleanSearchingConfigurationsPaginated,
  startSearchingConfigurationPaginated,
} from "../../app/actions/configurationActions";*/

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogSectionCleanSearchText, catalogSectionSetSearchText, cleanSearchingCatalogSectionsPaginated, startSearchingCatalogSectionsPaginated } from "../../app/actions/catalogSectionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackCatalogSection = ({ searchText, setSearchText, itemsPerPage, setIsDisabledSearchText, isDisabledSearchText, setIsDisabledFilter, isDisabledFilter }) => {
      debugLogPages(":: SearchBackCatalogSection");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      setIsDisabledFilter(true);
      setIsDisabledSearchText(false);

      trackEvent({ component: "SearchCatalogSections", event: "SearchCatalogSections-Clicked", search: event.target.value });

      dispatch(catalogSectionSetSearchText(event.target.value));

      dispatch(startSearchingCatalogSectionsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      setIsDisabledFilter(false);
      setIsDisabledSearchText(false);
      
      dispatch(cleanSearchingCatalogSectionsPaginated());

      dispatch(catalogSectionCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
            disabled={isDisabledSearchText}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalogSection;
